import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Config } from '../../config/config';
import { QuyTrinhXuLyThietBi } from './quy-trinh-xu-ly-thiet-bi';
@Injectable()
export class QuyTrinhXuLyThietBiService {

    controller:string = 'XL_QuyTrinhThietBi';
    constructor(private http: Http) { }
    
    GetList(paging:number,maxSize:number, keyword: string,idLoai:number,idHang:number,idDong:number,idApDung:number) {
        let headers = new Headers();
        let currentPage = paging - 1;
       
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/GetList?offset="+ currentPage+"&pageSize="+ maxSize + "&keyword=" + keyword+ "&idLoaiThietBi=" + idLoai+ "&idHangSanXuat=" + idHang+ "&idDongThietBi=" + idDong+"&idApDung="+idApDung, { headers: headers }).map(resp => resp.json());       
    }
    GetListAll() {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/GetList?offset=0&pageSize=1000&keyword=&idLoaiThietBi=0&idHangSanXuat=0&idDongThietBi=0", { headers: headers }).map(resp => resp.json());       
    }
    GetListMucDo(IdQuyTrinh:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");        
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.get(Config.apiUrl +this.controller+ "/GetListMucDo?idQuyTrinh=" + IdQuyTrinh, { headers: headers }).map(resp => resp.json());       
    }
    Save(item:QuyTrinhXuLyThietBi) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller+'/save', item, { headers: headers }).map(resp => resp.json());
    }
    Coppy(IdQuyTrinhNguon:number,IdQuyTrinhDich:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + this.controller+'/Coppy?idQuyTrinhNguon='+IdQuyTrinhNguon+'&idQuyTrinhDich='+IdQuyTrinhDich, { headers: headers }).map(resp => resp.json());
    }
    Delete(item:QuyTrinhXuLyThietBi) {
        item.TrangThai = 0;
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller+'/save', item, { headers: headers }).map(resp => resp.json());
    }
    Apply(item:QuyTrinhXuLyThietBi) {
        item.TrangThaiApDung = 1;
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller+'/Apply', item, { headers: headers }).map(resp => resp.json());
    }
    UnApply(item:QuyTrinhXuLyThietBi) {
        item.TrangThaiApDung = 0;
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.post(Config.apiUrl + this.controller+'/Apply', item, { headers: headers }).map(resp => resp.json());
    }
    saveMucDoQuyTrinh(IdQuyTrinh:number, mergelist: any) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.post(Config.apiUrl +this.controller+ '/saveQuyTrinhMucDo?idQuyTrinh=' + IdQuyTrinh, JSON.stringify(mergelist), {
            headers: headers
        }).map(resp => resp.json())
    }
    CheckYeuCau(IdQuyTrinh:number) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        return this.http.get(Config.apiUrl + this.controller+'/CheckYeuCau?idQuyTrinh='+IdQuyTrinh, { headers: headers }).map(resp => resp.json());
    }
    CoppyList(idQuyTrinhNguon: number,IdLoai:number,option:number, listThietBi: number[]) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));

        return this.http.post(Config.apiUrl +'XL_QuyTrinh/CoppyList?idQuyTrinhNguon=' + idQuyTrinhNguon+'&idLoai='+IdLoai+'&option='+option, JSON.stringify(listThietBi), {
            headers: headers
        }).map(resp => resp.json())
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/quy-trinh-xu-ly-thiet-bi/quy-trinh-xu-ly-thiet-bi.service.ts